import { Icon, SpeedDial, SpeedDialAction } from '@mui/material';

// Basic media controls using the mui SpeedDial component
// Expects an array of icons with a tooltipTitle, onClick, icon prop, and optional visible prop.

export default function MediaControls({ actionIcons, direction = 'left' }) {
    return (
        <SpeedDial direction={direction} icon={<Icon>more_vert</Icon>} ariaLabel="Media Controls">
            {actionIcons.map((control, index) => (
                <SpeedDialAction
                    open={control.visible !== false}
                    variant={control.variation || 'enabled'}
                    key={index}
                    tooltipTitle={control.tooltipTitle}
                    onClick={control.onClick}
                    icon={<Icon>{control.icon}</Icon>}
                />
            ))}
        </SpeedDial>
    );
}
